'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MultiSorter = function () {
    function MultiSorter(ordering) {
        _classCallCheck(this, MultiSorter);

        this.ordering = ordering.split(/\s*,\s*/).map(function (fieldOrder) {
            return new SortOrdering(fieldOrder);
        });
    }

    _createClass(MultiSorter, [{
        key: 'sort',
        value: function sort(items) {
            return items.sort(this.comparison());
        }
    }, {
        key: 'comparison',
        value: function comparison() {
            var _this = this;

            return function (item1, item2) {
                return _this.ordering.reduce(orderingReducer, 0);

                function orderingReducer(difference, order) {
                    var field = order.field,
                        direction = order.direction;


                    if (difference === 0) {
                        var value1 = item1[field];
                        var value2 = item2[field];

                        // We will sort undefined and null after anything else

                        if (illDefined(value1)) {
                            if (illDefined(value2)) {
                                return 0;
                            } else {
                                return -1;
                            }
                        } else {
                            if (illDefined(value2)) {
                                return 1;
                            } else {
                                var _difference = compare(value1, value2);
                                var multiplier = direction === Ordering.ASCENDING ? 1 : -1;

                                return _difference * multiplier;
                            }
                        }
                    } else {
                        return difference;
                    }
                }

                function illDefined(value) {
                    return value === undefined || value === null;
                }

                function compare(value1, value2) {
                    var type1 = typeof value1 === 'undefined' ? 'undefined' : _typeof(value1);

                    if (type1 === 'string') {
                        return value1.localeCompare(value2);
                    } else if (type1 === 'boolean') {
                        // Sort false before true

                        if (value1 && !value2) return 1;else if (!value1 && value2) return -1;else return 0;
                    } else if (type1 === 'number') {
                        return value1 - value2;
                    } else {
                        // We have no idea what to do with this,
                        // so just assume they are equivalent.

                        return 0;
                    }
                }
            };
        }
    }]);

    return MultiSorter;
}();

exports.default = MultiSorter;

// Helper code

var Ordering = {
    ASCENDING: 'ascending',
    DESCENDING: 'descending'
};

var SortOrdering = function SortOrdering(fieldOrdering) {
    _classCallCheck(this, SortOrdering);

    var match = fieldOrdering.match(/^-(.*)$/);

    if (match === null) {
        this.direction = Ordering.ASCENDING;
        this.field = fieldOrdering;
    } else {
        this.direction = Ordering.DESCENDING;
        this.field = match[1];
    }
};

// Some simple tests ...

if (false) {
    var items = [{ id: 1, name: 'zebra' }, { id: 1, name: 'cougar' }, { id: 3, name: 'orangutan' }, { id: 3, name: 'tiger' }, { id: 2, name: 'yak' }, { id: 2, name: 'wilderbeast' }];

    console.log('Unsorted');
    console.log(items);

    var TEST_ORDERS = ['id', '-id', 'name', '-name', 'id,name', '-id,name', 'id,-name', '-id,-name'];

    TEST_ORDERS.forEach(function (order) {
        var sorter = new MultiSorter(order);

        console.log();
        console.log('Sorted by', order, '...');
        console.log(sorter.sort(items));
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/resource/lib/multi-sorter.js
// module id = 473
// module chunks = 4